import { DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs } from 'cerialize';
import { ITransitProgramRequirementStatus } from '../interfaces';
import { ScreeningReason } from './screening-reason';

export class ScreeningPackageStatus implements ITransitProgramRequirementStatus {
  @autoserialize
  driverId: number;

  @autoserialize
  screeningPackageName: string;

  @autoserialize
  screeningPackageCode: string;

  @autoserialize
  status: string;

  @autoserialize
  substanceScreening: boolean;

  @autoserialize
  screeningId: number;

  @autoserializeAs(Date)
  expirationDate: Date;

  @autoserializeAs(ScreeningReason)
  screeningReason: ScreeningReason;

  @autoserializeAs(Date)
  requiredByDate: Date;

  @autoserializeAs(Date)
  completedDate: Date;

  /**** Serialization ****/

  static OnSerialized(instance: ScreeningPackageStatus, json: any): void {
    if (!isNullOrUndefined(instance.completedDate)) {
      json.completedDate = DateUtil.serializeLocalDate(instance.completedDate);
    }

    if (!isNullOrUndefined(instance.requiredByDate)) {
      json.requiredByDate = DateUtil.serializeLocalDate(instance.requiredByDate);
    }

    if (!isNullOrUndefined(instance.expirationDate)) {
      json.expirationDate = DateUtil.serializeLocalDate(instance.expirationDate);
    }
  }

  static OnDeserialized(instance: ScreeningPackageStatus, json: any): void {
    if (!isNullOrUndefined(json['completedDate'])) {
      instance.completedDate = DateUtil.deserializeLocalDate(json['completedDate']);
    }

    if (!isNullOrUndefined(json['requiredByDate'])) {
      instance.requiredByDate = DateUtil.deserializeLocalDate(json['requiredByDate']);
    }

    if (!isNullOrUndefined(json['expirationDate'])) {
      instance.expirationDate = DateUtil.deserializeLocalDate(json['expirationDate']);
    }
  }
}
